import { Product } from "../productsData";

const products: Product[] = [
  {
    imgForProductCard:
      "https://res.cloudinary.com/du3oueesv/image/upload/v1659873489/shopping%20cart/half%20sleeve%20cut/mthcssp10-solid-350x435_zvwuma.jpg",
    name: "Half Sleeve Cut and Sew Solid(pattern 10)",
    pathName: "half-sleeve-cut-and-sew-solid-pattern-10",
    price: "৳450",
    breadCrumbs: [],
    fullPath: "",
    imagesForProductPage: [],
    details: [],
    fabric: [],
    color: [],
    size: [],
    description: [],
    additionalInfo: {
      weight: "",
      fabric: "",
      size: "",
    },
  },
  {
    imgForProductCard:
      "https://res.cloudinary.com/du3oueesv/image/upload/v1659873473/shopping%20cart/half%20sleeve%20cut/mthcssp11-solid-350x435_jooe3k.jpg",
    name: "Half Sleeve Cut and Sew Solid(pattern 11)",
    pathName: "half-sleeve-cut-and-sew-solid-pattern-11",
    price: "৳450",
    breadCrumbs: [],
    fullPath: "",
    imagesForProductPage: [],
    details: [],
    fabric: [],
    color: [],
    size: [],
    description: [],
    additionalInfo: {
      weight: "",
      fabric: "",
      size: "",
    },
  },
  {
    imgForProductCard:
      "https://res.cloudinary.com/du3oueesv/image/upload/v1659873453/shopping%20cart/half%20sleeve%20cut/mthcssp12-solid-350x435_zkricr.jpg",
    name: "Half Sleeve Cut and Sew Solid(pattern 12)",
    pathName: "half-sleeve-cut-and-sew-solid-pattern-12",
    price: "৳450",
    breadCrumbs: [],
    fullPath: "",
    imagesForProductPage: [],
    details: [],
    fabric: [],
    color: [],
    size: [],
    description: [],
    additionalInfo: {
      weight: "",
      fabric: "",
      size: "",
    },
  },
  {
    imgForProductCard:
      "https://res.cloudinary.com/du3oueesv/image/upload/v1659873413/shopping%20cart/half%20sleeve%20cut/mthcssp13-solid-350x435_zutbr0.jpg",
    name: "Half Sleeve Cut and Sew Solid(pattern 13)",
    pathName: "half-sleeve-cut-and-sew-solid-pattern-13",
    price: "৳450",
    breadCrumbs: [],
    fullPath: "",
    imagesForProductPage: [],
    details: [],
    fabric: [],
    color: [],
    size: [],
    description: [],
    additionalInfo: {
      weight: "",
      fabric: "",
      size: "",
    },
  },
  {
    imgForProductCard:
      "https://res.cloudinary.com/du3oueesv/image/upload/v1659873393/shopping%20cart/half%20sleeve%20cut/mthcssp14-solid-350x435_sc3l07.jpg",
    name: "Half Sleeve Cut and Sew Solid(pattern 14)",
    pathName: "half-sleeve-cut-and-sew-solid-pattern-14",
    price: "৳450",
    breadCrumbs: [],
    fullPath: "",
    imagesForProductPage: [],
    details: [],
    fabric: [],
    color: [],
    size: [],
    description: [],
    additionalInfo: {
      weight: "",
      fabric: "",
      size: "",
    },
  },
  {
    imgForProductCard:
      "https://res.cloudinary.com/du3oueesv/image/upload/v1659873363/shopping%20cart/half%20sleeve%20cut/mthcssp15-solid-350x435_mz8sws.jpg",
    name: "Half Sleeve Cut and Sew Solid(pattern 15)",
    pathName: "half-sleeve-cut-and-sew-solid-pattern-15",
    price: "৳450",
    breadCrumbs: [],
    fullPath: "",
    imagesForProductPage: [],
    details: [],
    fabric: [],
    color: [],
    size: [],
    description: [],
    additionalInfo: {
      weight: "",
      fabric: "",
      size: "",
    },
  },
];

export default products;
